/* tms-chat.js — LE CHAT NINO DE LA BOUTIQUE (lot 17, décisions d'Alex du 2026-10-13).

   Un panneau NATIF qui parle à l'API chat du produit, celle de app.tellmestories.ai/chat : même
   conversation, mêmes règles. Ce fichier ne décide rien que l'API ne décide déjà ; il affiche, il envoie.

   · LA SESSION NAÎT AU PREMIER GESTE, jamais à l'ouverture : elle vaut inscription côté produit (conditions
     acceptées, une histoire offerte, événement publicitaire). Ouvrir le panneau ne coûte rien.
   · Le jeton chat se range sous `tms_chat_token` (même nom que /chat, sur NOTRE origine) ; il voyage en
     `Authorization`, jamais dans une adresse de l'API (`token_in_query`).
   · LA FAMILLE NAÎT CÔTÉ PRODUIT (`POST /v1/families/me`, décision 5) ; elle est prête quand
     `GET /v1/families/me` rend au moins un membre (le job les écrit tous d'un coup), ou quand le fil porte
     `intent: family_ready`. Alors la galerie l'IMPORTE (`POST /famille/import`, preuve = ce jeton chat,
     confirmé par l'API) et rend un jeton de galerie, rangé dans l'onglet (`tms_jeton`, lu par le bloc de la
     fiche) : on ouvre la fiche du mug sur #order-preview, SANS jeton dans l'adresse.
   · L'approbation et le panier vivent sur la fiche seulement (décision 3) : ce panneau n'a ni l'un ni l'autre.
   · Plein écran = /chat dans un nouvel onglet, sur la même conversation (`?token=`, capturé puis effacé par
     /chat). ⚠️ Une personne connectée sur l'app y retrouve SON compte, pas ce fil.
   · Panne (session impossible, API muette) → « Nino is resting » et le parcours, jamais une erreur levée.
   · Langue : celle du navigateur (décision 9). */
(function () {
  "use strict";

  var racine = document.querySelector('[data-chat="racine"]');
  if (!racine || racine.getAttribute("data-chat-pret")) return;
  racine.setAttribute("data-chat-pret", "1");

  var CFG = {
    api: racine.getAttribute("data-api"),
    galerie: racine.getAttribute("data-galerie"),
    app: racine.getAttribute("data-app"),
    fiche: racine.getAttribute("data-fiche"),
    parcours: racine.getAttribute("data-parcours"),
    conditions: racine.getAttribute("data-conditions"),
    nino: racine.getAttribute("data-nino"),
    /* (lot 11 comptes) Sur la page du parcours : aucun lanceur, tant qu'un échec n'appelle pas Nino. */
    discret: racine.getAttribute("data-discret") === "1"
  };
  var CLE_JETON = "tms_chat_token";
  var CLE_GALERIE = "tms_jeton";
  var SONDAGE_MS = 5000;
  var FAMILLE_MS = 10000;
  var FAMILLE_MAX_MS = 8 * 60 * 1000;
  var PHOTOS_MAX = 6;
  var PHOTO_COTE = 1600;
  var MI_VIE_S = 15 * 24 * 3600;

  /* Lot 01 boutique-langue : la langue de la PAGE (`<html lang>`, posée par Shopify), jamais celle du navigateur : un
     visiteur qui choisit le français sur la boutique doit le garder dans la discussion aussi. */
  /* 🔴 (lot 05 boutique-langue) toute langue de TEXTES, jamais une liste fr/en : le code de la page (`nl`, `pt-BR`) est
     cherché tel quel, puis sur ses deux lettres ; une langue sans textes sert l'anglais. */
  var LANGUE_PAGE = String(document.documentElement.lang || "");
  var TEXTES = {
    en: {
      lanceur: "Chat with Nino", fermerLanceur: "Close the chat", nom: "Nino", sous: "Automated helper",
      fermer: "Close the chat", plein: "Open the chat in full screen", journal: "Conversation with Nino",
      nino: "Nino:", moi: "You:", saisie: "Message to Nino", placeholder: "Write to Nino", envoyer: "Send",
      photos: "Add photos",
      accueil: "Hi, I'm Nino. Send me one photo of each person, up to 6 of you, and I'll draw your family. Or just tell me what you'd like.",
      conditions: "By starting here you accept our", conditionsLien: "Terms & Conditions",
      repos: "Nino is resting right now. You can still create your family here:", reposLien: "Create my family",
      nPhotos: function (n) { return n === 1 ? "1 photo" : n + " photos"; },
      dessin: "Thank you. I'm drawing everyone now. It takes 2 to 8 minutes: keep browsing if you like, I'll tell you here.",
      enDessin: "Drawing your family",
      prete: "Your family is ready.", versFiche: "See them on a mug",
      versFicheEnCours: "Opening your mug…",
      presque: "Your portraits are almost there. Try again in a moment.",
      importKo: "I couldn't open your mug just now. Try again, or create your family here:",
      tropLong: "This is taking longer than usual. I'll keep your family: come back to this chat in a few minutes.",
      photoKo: function (n) { return "Photo " + n + " can't be used. Try another one (JPEG or PNG)."; },
      limite: "You've drawn a lot of families today. Come back tomorrow.",
      pasEnvoye: "Not sent.", reessayer: "Try again",
      pause: "Nino needs a short break. Try again in a minute.",
      expire: "Your conversation expired. Send your message again.",
      continuer: "Continue in full screen"
    },
    fr: {
      lanceur: "Discuter avec Nino", fermerLanceur: "Fermer la discussion", nom: "Nino", sous: "Assistant automatique",
      fermer: "Fermer la discussion", plein: "Ouvrir la discussion en plein écran", journal: "Discussion avec Nino",
      nino: "Nino :", moi: "Vous :", saisie: "Message pour Nino", placeholder: "Écrire à Nino", envoyer: "Envoyer",
      photos: "Ajouter des photos",
      accueil: "Bonjour, je suis Nino. Envoyez-moi une photo de chaque personne, jusqu'à 6, et je dessine votre famille. Ou dites-moi simplement ce que vous aimeriez.",
      conditions: "En commençant ici, vous acceptez nos", conditionsLien: "CGU / CGV",
      repos: "Nino se repose pour le moment. Vous pouvez créer votre famille ici :", reposLien: "Créer ma famille",
      nPhotos: function (n) { return n === 1 ? "1 photo" : n + " photos"; },
      dessin: "Merci. Je dessine tout le monde. Cela prend de 2 à 8 minutes : continuez votre visite si vous voulez, je vous le dis ici.",
      enDessin: "Votre famille se dessine",
      prete: "Votre famille est prête.", versFiche: "La voir sur un mug",
      versFicheEnCours: "Ouverture de votre mug…",
      presque: "Vos portraits arrivent. Réessayez dans un instant.",
      importKo: "Je n'ai pas pu ouvrir votre mug. Réessayez, ou créez votre famille ici :",
      tropLong: "C'est plus long que d'habitude. Je garde votre famille : revenez dans cette discussion dans quelques minutes.",
      photoKo: function (n) { return "La photo " + n + " ne peut pas servir. Essayez-en une autre (JPEG ou PNG)."; },
      limite: "Vous avez dessiné beaucoup de familles aujourd'hui. Revenez demain.",
      pasEnvoye: "Non envoyé.", reessayer: "Réessayer",
      pause: "Nino fait une petite pause. Réessayez dans une minute.",
      expire: "Votre discussion a expiré. Renvoyez votre message.",
      continuer: "Continuer en plein écran"
    },
    nl: {
      lanceur: "Chat met Nino", fermerLanceur: "Sluit de chat", nom: "Nino", sous: "Automatische hulp",
      fermer: "Sluit de chat", plein: "Open de chat op volledig scherm", journal: "Gesprek met Nino",
      nino: "Nino:", moi: "Jij:", saisie: "Bericht aan Nino", placeholder: "Schrijf naar Nino", envoyer: "Versturen",
      photos: "Foto's toevoegen",
      accueil: "Hoi, ik ben Nino. Stuur me een foto van elke persoon, tot 6 in totaal, en ik teken je familie. Of vertel me gewoon wat je graag wilt.",
      conditions: "Door hier te beginnen, ga je akkoord met onze", conditionsLien: "Algemene voorwaarden",
      repos: "Nino rust even. Je kunt je familie hier maken:", reposLien: "Maak mijn familie",
      nPhotos: function (n) { return n === 1 ? "1 foto" : n + " foto's"; },
      dessin: "Dank je. Ik teken nu iedereen. Dat duurt 2 tot 8 minuten: kijk gerust verder rond, ik laat het je hier weten.",
      enDessin: "Je familie wordt getekend",
      prete: "Je familie is klaar.", versFiche: "Bekijk ze op een mok",
      versFicheEnCours: "Je mok wordt geopend…",
      presque: "Je portretten zijn er bijna. Probeer het zo opnieuw.",
      importKo: "Ik kon je mok nu niet openen. Probeer het opnieuw, of maak je familie hier:",
      tropLong: "Dit duurt langer dan normaal. Ik bewaar je familie: kom over een paar minuten terug in deze chat.",
      photoKo: function (n) { return "Foto " + n + " kan niet gebruikt worden. Probeer een andere (JPEG of PNG)."; },
      limite: "Je hebt vandaag veel families getekend. Kom morgen terug.",
      pasEnvoye: "Niet verstuurd.", reessayer: "Opnieuw proberen",
      pause: "Nino neemt een korte pauze. Probeer het over een minuut opnieuw.",
      expire: "Je gesprek is verlopen. Stuur je bericht opnieuw.",
      continuer: "Verder op volledig scherm"
    },
    de: {
      lanceur: "Mit Nino chatten", fermerLanceur: "Chat schließen", nom: "Nino", sous: "Automatische Hilfe",
      fermer: "Chat schließen", plein: "Chat im Vollbild öffnen", journal: "Gespräch mit Nino",
      nino: "Nino:", moi: "Sie:", saisie: "Nachricht an Nino", placeholder: "Schreiben Sie Nino", envoyer: "Senden",
      photos: "Fotos hinzufügen",
      accueil: "Hallo, ich bin Nino. Schicken Sie mir ein Foto von jeder Person, bis zu 6 insgesamt, und ich zeichne Ihre Familie. Oder sagen Sie mir einfach, was Sie sich wünschen.",
      conditions: "Wenn Sie hier beginnen, akzeptieren Sie unsere", conditionsLien: "AGB",
      repos: "Nino ruht sich kurz aus. Hier können Sie Ihre Familie erstellen:", reposLien: "Meine Familie erstellen",
      nPhotos: function (n) { return n === 1 ? "1 Foto" : n + " Fotos"; },
      dessin: "Danke. Ich zeichne jetzt alle. Das dauert 2 bis 8 Minuten: Schauen Sie sich gern weiter um, ich sage Ihnen hier Bescheid.",
      enDessin: "Ihre Familie wird gezeichnet",
      prete: "Ihre Familie ist fertig.", versFiche: "Auf einer Tasse ansehen",
      versFicheEnCours: "Ihre Tasse wird geöffnet…",
      presque: "Ihre Porträts sind gleich da. Versuchen Sie es in einem Moment noch einmal.",
      importKo: "Ich konnte Ihre Tasse gerade nicht öffnen. Versuchen Sie es noch einmal, oder erstellen Sie Ihre Familie hier:",
      tropLong: "Das dauert länger als sonst. Ich behalte Ihre Familie: Kommen Sie in ein paar Minuten in diesen Chat zurück.",
      photoKo: function (n) { return "Foto " + n + " lässt sich nicht verwenden. Versuchen Sie ein anderes (JPEG oder PNG)."; },
      limite: "Sie haben heute schon viele Familien gezeichnet. Kommen Sie morgen wieder.",
      pasEnvoye: "Nicht gesendet.", reessayer: "Erneut versuchen",
      pause: "Nino macht eine kurze Pause. Versuchen Sie es in einer Minute noch einmal.",
      expire: "Ihr Gespräch ist abgelaufen. Senden Sie Ihre Nachricht noch einmal.",
      continuer: "Im Vollbild weiter"
    },
    es: {
      lanceur: "Chatea con Nino", fermerLanceur: "Cerrar el chat", nom: "Nino", sous: "Ayuda automática",
      fermer: "Cerrar el chat", plein: "Abrir el chat en pantalla completa", journal: "Conversación con Nino",
      nino: "Nino:", moi: "Tú:", saisie: "Mensaje para Nino", placeholder: "Escríbele a Nino", envoyer: "Enviar",
      photos: "Añadir fotos",
      accueil: "Hola, soy Nino. Envíame una foto de cada persona, hasta 6 en total, y dibujo a tu familia. O dime simplemente qué te gustaría.",
      conditions: "Al empezar aquí, aceptas nuestras", conditionsLien: "condiciones de venta",
      repos: "Nino está descansando un momento. Aquí puedes crear a tu familia:", reposLien: "Crear mi familia",
      nPhotos: function (n) { return n === 1 ? "1 foto" : n + " fotos"; },
      dessin: "Gracias. Ya estoy dibujando a todos. Tarda de 2 a 8 minutos: sigue mirando la tienda si quieres, te aviso aquí.",
      enDessin: "Estamos dibujando a tu familia",
      prete: "Tu familia está lista.", versFiche: "Verla en una taza",
      versFicheEnCours: "Abriendo tu taza…",
      presque: "Tus retratos están casi listos. Vuelve a intentarlo en un momento.",
      importKo: "No pude abrir tu taza. Vuelve a intentarlo, o crea a tu familia aquí:",
      tropLong: "Está tardando más de lo normal. Guardo a tu familia: vuelve a este chat en unos minutos.",
      photoKo: function (n) { return "No se puede usar la foto " + n + ". Prueba con otra (JPEG o PNG)."; },
      limite: "Hoy ya dibujaste muchas familias. Vuelve mañana.",
      pasEnvoye: "No enviado.", reessayer: "Reintentar",
      pause: "Nino hace una pausa corta. Vuelve a intentarlo en un minuto.",
      expire: "Tu conversación caducó. Vuelve a enviar tu mensaje.",
      continuer: "Continuar en pantalla completa"
    },
    it: {
      lanceur: "Parla con Nino", fermerLanceur: "Chiudi la conversazione", nom: "Nino", sous: "Assistente automatico",
      fermer: "Chiudi la conversazione", plein: "Apri la conversazione a schermo intero", journal: "Conversazione con Nino",
      nino: "Nino:", moi: "Tu:", saisie: "Messaggio per Nino", placeholder: "Scrivi a Nino", envoyer: "Invia",
      photos: "Aggiungi foto",
      accueil: "Ciao, sono Nino. Mandami una foto di ogni persona, fino a 6 in tutto, e disegno la tua famiglia. Oppure dimmi semplicemente cosa ti piacerebbe.",
      conditions: "Iniziando qui accetti le nostre", conditionsLien: "condizioni di vendita",
      repos: "Nino si sta riposando un momento. Puoi creare la tua famiglia qui:", reposLien: "Crea la mia famiglia",
      nPhotos: function (n) { return n === 1 ? "1 foto" : n + " foto"; },
      dessin: "Grazie. Sto già disegnando tutti. Ci vogliono da 2 a 8 minuti: continua pure a guardare il negozio, ti avviso qui.",
      enDessin: "Stiamo disegnando la tua famiglia",
      prete: "La tua famiglia è pronta.", versFiche: "Guardala su una tazza",
      versFicheEnCours: "Apro la tua tazza…",
      presque: "I tuoi ritratti sono quasi pronti. Riprova tra un momento.",
      importKo: "Non sono riuscito ad aprire la tua tazza. Riprova, oppure crea la tua famiglia qui:",
      tropLong: "Ci vuole più del solito. Tengo da parte la tua famiglia: torna in questa conversazione tra qualche minuto.",
      photoKo: function (n) { return "La foto " + n + " non si può usare. Provane un'altra (JPEG o PNG)."; },
      limite: "Oggi hai già disegnato molte famiglie. Torna domani.",
      pasEnvoye: "Non inviato.", reessayer: "Riprova",
      pause: "Nino si prende una breve pausa. Riprova tra un minuto.",
      expire: "La tua conversazione è scaduta. Invia di nuovo il tuo messaggio.",
      continuer: "Continua a schermo intero"
    },
    "pt-PT": {
      lanceur: "Falar com o Nino", fermerLanceur: "Fechar a conversa", nom: "Nino", sous: "Assistente automático",
      fermer: "Fechar a conversa", plein: "Abrir a conversa em ecrã inteiro", journal: "Conversa com o Nino",
      nino: "Nino:", moi: "Eu:", saisie: "Mensagem para o Nino", placeholder: "Escreva ao Nino", envoyer: "Enviar",
      photos: "Adicionar fotografias",
      accueil: "Olá, sou o Nino. Envie-me uma fotografia de cada pessoa, até 6 no total, e eu desenho a sua família. Ou diga-me simplesmente o que gostaria.",
      conditions: "Ao começar aqui, está a aceitar as nossas", conditionsLien: "Condições de venda",
      repos: "O Nino está a descansar neste momento. Pode criar a sua família aqui:", reposLien: "Criar a minha família",
      nPhotos: function (n) { return n === 1 ? "1 fotografia" : n + " fotografias"; },
      dessin: "Obrigado. Já estou a desenhar toda a gente. Demora entre 2 e 8 minutos: pode continuar a ver a loja, eu aviso aqui.",
      enDessin: "Estamos a desenhar a sua família",
      prete: "A sua família está pronta.", versFiche: "Veja-a numa caneca",
      versFicheEnCours: "A abrir a sua caneca…",
      presque: "Os seus retratos estão quase prontos. Tente de novo dentro de um momento.",
      importKo: "Não consegui abrir a sua caneca agora. Tente de novo, ou crie a sua família aqui:",
      tropLong: "Está a demorar mais do que o habitual. Guardo a sua família: volte a esta conversa daqui a alguns minutos.",
      photoKo: function (n) { return "A fotografia " + n + " não pode ser usada. Experimente outra (JPEG ou PNG)."; },
      limite: "Já desenhou muitas famílias hoje. Volte amanhã.",
      pasEnvoye: "Não enviada.", reessayer: "Tentar de novo",
      pause: "O Nino precisa de uma pequena pausa. Tente de novo dentro de um minuto.",
      expire: "A sua conversa expirou. Envie de novo a sua mensagem.",
      continuer: "Continuar em ecrã inteiro"
    },
    "pt-BR": {
      lanceur: "Conversar com o Nino", fermerLanceur: "Fechar a conversa", nom: "Nino", sous: "Assistente automático",
      fermer: "Fechar a conversa", plein: "Abrir a conversa em tela cheia", journal: "Conversa com o Nino",
      nino: "Nino:", moi: "Você:", saisie: "Mensagem para o Nino", placeholder: "Escreva para o Nino", envoyer: "Enviar",
      photos: "Adicionar fotos",
      accueil: "Oi, eu sou o Nino. Envie uma foto de cada pessoa, até 6 pessoas, e eu desenho sua família. Ou, se preferir, me conte o que você gostaria.",
      conditions: "Ao começar aqui, você aceita nossas", conditionsLien: "Condições de venda",
      repos: "O Nino está descansando agora. Você ainda pode criar sua família aqui:", reposLien: "Criar minha família",
      nPhotos: function (n) { return n === 1 ? "1 foto" : n + " fotos"; },
      dessin: "Obrigado. Estou desenhando todo mundo agora. Leva de 2 a 8 minutos: continue navegando se quiser, eu aviso aqui.",
      enDessin: "Desenhando sua família",
      prete: "Sua família está pronta.", versFiche: "Veja sua família em uma caneca",
      versFicheEnCours: "Abrindo sua caneca…",
      presque: "Seus retratos estão quase prontos. Tente de novo daqui a pouco.",
      importKo: "Não consegui abrir sua caneca agora. Tente de novo ou crie sua família aqui:",
      tropLong: "Está demorando mais do que o normal. Vou guardar sua família: volte a esta conversa em alguns minutos.",
      photoKo: function (n) { return "A foto " + n + " não pode ser usada. Tente outra (JPEG ou PNG)."; },
      limite: "Você já desenhou muitas famílias hoje. Volte amanhã.",
      pasEnvoye: "Não enviada.", reessayer: "Tentar de novo",
      pause: "O Nino precisa de uma pausa curta. Tente de novo em um minuto.",
      expire: "Sua conversa expirou. Envie sua mensagem de novo.",
      continuer: "Continuar em tela cheia"
    }
  };
  /* 🔴 (lot 10 boutique-langue, revue) la casse ne compte pas (« pt-br »), et une forme SEULE prend la variante par
     défaut de sa langue (« pt » ⇒ `pt-BR`), comme `courriel.VARIANTE_PAR_DEFAUT` côté service. */
  var VARIANTE_PAR_DEFAUT = { pt: "pt-BR" };
  function langueDe(brut) {
    var bas = brut.toLowerCase().replace("_", "-"), deux = bas.slice(0, 2);
    for (var k in TEXTES) { if (k.toLowerCase() === bas) { return k; } }
    if (bas.length === 2 && TEXTES[VARIANTE_PAR_DEFAUT[deux]]) { return VARIANTE_PAR_DEFAUT[deux]; }
    return TEXTES[deux] ? deux : "en";
  }
  var LANGUE = langueDe(LANGUE_PAGE);
  /* La langue dite à l'API du chat (produit) : seules celles que son contrat connaît (en, fr) ; les autres y parlent
     anglais, l'écran garde sa langue. */
  var LANGUE_API = /^(en|fr)$/.test(LANGUE) ? LANGUE : "en";
  var T = TEXTES[LANGUE];

  var lanceur = racine.querySelector('[data-chat="lanceur"]');
  var flottant = racine.querySelector('[data-chat="panneau"]');
  var voile = racine.querySelector('[data-chat="voile"]');
  var ecranEtroit = window.matchMedia ? window.matchMedia("(max-width: 760px)") : { matches: false };

  /* ── outils ─────────────────────────────────────────────────────────────────────────────── */
  function el(nom, attrs, enfants) {
    var n = document.createElement(nom);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === "texte") n.textContent = attrs[k];
      else if (attrs[k] !== null && attrs[k] !== undefined && attrs[k] !== false) n.setAttribute(k, attrs[k] === true ? "" : attrs[k]);
    });
    (enfants || []).forEach(function (e) { if (e) n.appendChild(typeof e === "string" ? document.createTextNode(e) : e); });
    return n;
  }
  function svg(chemin) {
    var s = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    s.setAttribute("width", "20"); s.setAttribute("height", "20"); s.setAttribute("viewBox", "0 0 24 24");
    s.setAttribute("fill", "none"); s.setAttribute("stroke", "currentColor"); s.setAttribute("stroke-width", "2.2");
    s.setAttribute("stroke-linecap", "round"); s.setAttribute("stroke-linejoin", "round"); s.setAttribute("aria-hidden", "true");
    s.setAttribute("focusable", "false");
    chemin.split("|").forEach(function (d) {
      var p = document.createElementNS("http://www.w3.org/2000/svg", "path"); p.setAttribute("d", d); s.appendChild(p);
    });
    return s;
  }
  var ICONES = {
    fermer: "M6 6l12 12|M18 6L6 18",
    plein: "M14 4h6v6|M20 4l-7 7|M10 20H4v-6|M4 20l7-7",
    trombone: "M21 11.5l-8.6 8.6a5 5 0 0 1-7.1-7.1l8.6-8.6a3.3 3.3 0 0 1 4.7 4.7l-8.6 8.6a1.7 1.7 0 0 1-2.4-2.4l7.9-7.9",
    envoyer: "M22 2L11 13|M22 2l-7 20-4-9-9-4 20-7z",
    chevron: "M6 9l6 6 6-6"
  };
  function lire(cle) { try { return window.localStorage.getItem(cle); } catch (e) { return null; } }
  function ecrire(cle, v) { try { if (v) window.localStorage.setItem(cle, v); else window.localStorage.removeItem(cle); } catch (e) { /* stockage refusé */ } }
  function maintenant() { return Math.floor(Date.now() / 1000); }
  function claims(jeton) {
    try {
      var b = jeton.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
      while (b.length % 4) b += "=";
      return JSON.parse(decodeURIComponent(escape(window.atob(b))));
    } catch (e) { return null; }
  }
  function idMessage() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return "m" + Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
  }

  /* ── la session ─────────────────────────────────────────────────────────────────────────── */
  function jetonValide() {
    var j = lire(CLE_JETON);
    var c = j ? claims(j) : null;
    if (!c || c.channel !== "web" || !c.exp || c.exp <= maintenant() + 60) {
      if (j) ecrire(CLE_JETON, null);
      return null;
    }
    return j;
  }
  function uidSession() { var j = jetonValide(); var c = j ? claims(j) : null; return c ? c.user_id : null; }

  function appeler(methode, chemin, corps, avecJeton) {
    var entetes = {};
    if (corps !== undefined) entetes["Content-Type"] = "application/json";
    var j = avecJeton ? jetonValide() : null;
    if (avecJeton && !j) return Promise.resolve({ ok: false, statut: 401, donnees: {} });
    if (j) entetes.Authorization = "Bearer " + j;
    return fetch(CFG.api + chemin, {
      method: methode, headers: entetes, body: corps === undefined ? undefined : JSON.stringify(corps), credentials: "omit"
    }).then(function (r) {
      return r.text().then(function (t) {
        var d = {}; try { d = t ? JSON.parse(t) : {}; } catch (e) { d = {}; }
        return { ok: r.ok, statut: r.status, donnees: d && typeof d === "object" ? d : {} };
      });
    }, function () { return { ok: false, statut: 0, donnees: {} }; });
  }

  function provenance() {
    var q = new URLSearchParams(window.location.search), utm = {};
    [["utm_source", "source"], ["utm_medium", "medium"], ["utm_campaign", "campaign"], ["utm_term", "term"],
      ["utm_content", "content"], ["fbclid", "fbclid"], ["ttclid", "ttclid"]].forEach(function (p) {
      var v = q.get(p[0]); if (v) utm[p[1]] = v.slice(0, 512);
    });
    utm.sourceUrl = (window.location.origin + window.location.pathname).slice(0, 512);
    return utm;
  }

  var sessionEnCours = null;
  function assurerSession(porte) {
    if (jetonValide()) return Promise.resolve(true);
    if (sessionEnCours) return sessionEnCours;
    sessionEnCours = appeler("POST", "/chat/session",
      { termsAccepted: true, locale: LANGUE_API, utm: provenance(), porte: porte }, false).then(function (r) {
      sessionEnCours = null;
      if (r.ok && r.donnees.token) { ecrire(CLE_JETON, r.donnees.token); return true; }
      reposer();
      return false;
    });
    return sessionEnCours;
  }
  function rafraichirSiMiVie() {
    var j = jetonValide(), c = j ? claims(j) : null;
    if (!c || c.sid || c.exp - maintenant() > MI_VIE_S) return;
    appeler("POST", "/chat/session/refresh", undefined, true).then(function (r) {
      if (r.ok && r.donnees.token) ecrire(CLE_JETON, r.donnees.token);
    });
  }

  /* ── le panneau ─────────────────────────────────────────────────────────────────────────── */
  var D = {};
  function construire() {
    var avatar = function (taille) {
      return el("span", { "class": "chat-avatar" }, [el("img", { src: CFG.nino, alt: "", width: "347", height: "512", loading: "lazy" })]);
    };
    D.fil = el("ol", { "class": "chat-fil" });
    D.journal = el("div", { "class": "chat-journal", role: "log", "aria-live": "polite", "aria-label": T.journal }, [D.fil]);
    D.fermer = el("button", { type: "button", "class": "chat-fermer", "aria-label": T.fermer, "data-chat": "fermer" }, [svg(ICONES.fermer)]);
    D.plein = el("button", { type: "button", "class": "chat-fermer chat-plein", "aria-label": T.plein, title: T.plein, "data-chat": "plein-ecran" }, [svg(ICONES.plein)]);
    D.fichier = el("input", { type: "file", accept: "image/jpeg,image/png,image/webp", multiple: true, hidden: true, "data-chat": "fichier", tabindex: "-1", "aria-hidden": "true" });
    D.trombone = el("button", { type: "button", "class": "chat-rond chat-rond--trombone", "aria-label": T.photos, "data-chat": "photos" }, [svg(ICONES.trombone)]);
    D.texte = el("textarea", { rows: "1", "aria-label": T.saisie, placeholder: T.placeholder, maxlength: "4096", "data-chat": "saisie" });
    D.envoyer = el("button", { type: "button", "class": "chat-rond chat-rond--envoyer", "aria-label": T.envoyer, disabled: true, "data-chat": "envoyer" }, [svg(ICONES.envoyer)]);
    var panneau = el("div", { "class": "chat-panneau" }, [
      el("div", { "class": "chat-tete" }, [
        el("span", { "class": "chat-poignee", "aria-hidden": "true" }), avatar(40),
        el("div", { "class": "chat-tete__titres" }, [
          el("p", { "class": "chat-tete__nom", id: "chat-nino-titre", texte: T.nom }),
          el("p", { "class": "chat-tete__sous", texte: T.sous })]),
        D.plein, D.fermer]),
      D.journal,
      el("div", { "class": "chat-saisie" }, [D.trombone, D.fichier, D.texte, D.envoyer])
    ]);
    flottant.appendChild(panneau);
    D.avatar = avatar;
    lanceur.appendChild(el("span", { "class": "chat-lanceur__chevron", "aria-hidden": "true" }, [svg(ICONES.chevron)]));

    D.fermer.addEventListener("click", function () { fermer(); });
    D.plein.addEventListener("click", pleinEcran);
    D.trombone.addEventListener("click", function () { D.fichier.click(); });
    D.fichier.addEventListener("change", function () { var f = Array.prototype.slice.call(D.fichier.files || []); D.fichier.value = ""; if (f.length) envoyerPhotos(f); });
    D.texte.addEventListener("input", function () { D.envoyer.disabled = !D.texte.value.trim() || etat.repos; });
    D.texte.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && !e.shiftKey && !e.isComposing) { e.preventDefault(); envoyerSaisie(); }
    });
    D.envoyer.addEventListener("click", envoyerSaisie);
    flottant.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { e.preventDefault(); fermer(); return; }
      if (e.key === "Tab" && flottant.getAttribute("aria-modal") === "true") pieger(e);
    });
  }

  function focalisables() {
    return Array.prototype.filter.call(flottant.querySelectorAll("button, textarea, input, a[href]"), function (n) {
      return !n.disabled && !n.hidden && n.getAttribute("tabindex") !== "-1" && n.offsetParent !== null;
    });
  }
  function pieger(e) {
    var liste = focalisables(); if (!liste.length) return;
    var premier = liste[0], dernier = liste[liste.length - 1];
    if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
    else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
  }

  var etat = { ouvert: false, construit: false, charge: false, repos: false, entrees: {}, ordre: [], sondage: null, echecs: 0,
    familleDepuis: 0, familleMinuteur: null, famillePrete: false, carteFamille: false, prochainSondage: 0 };

  function ouvrir() {
    if (!etat.construit) { construire(); etat.construit = true; }
    etat.ouvert = true;
    var modal = !!ecranEtroit.matches;
    flottant.setAttribute("aria-modal", modal ? "true" : "false");
    flottant.hidden = false;
    voile.hidden = !modal;
    lanceur.setAttribute("aria-expanded", "true");
    lanceur.setAttribute("aria-label", T.fermerLanceur);
    if (!etat.charge) charger();
    demarrerSondage();
    D.texte.focus();
  }
  function fermer() {
    etat.ouvert = false;
    flottant.hidden = true;
    voile.hidden = true;
    lanceur.setAttribute("aria-expanded", "false");
    lanceur.setAttribute("aria-label", T.lanceur);
    arreterSondage();
    lanceur.focus();
    effacerPendantParcours();
  }

  /* ── le fil ─────────────────────────────────────────────────────────────────────────────── */
  function inline(texte) {
    /* Le balisage WhatsApp de l'API (*gras*, _italique_), échappé AVANT : jamais de HTML venu du fil. */
    var f = document.createDocumentFragment();
    var re = /\*([^*\n]+)\*|_([^_\n]+)_/g, dernier = 0, m;
    while ((m = re.exec(texte))) {
      if (m.index > dernier) f.appendChild(document.createTextNode(texte.slice(dernier, m.index)));
      f.appendChild(el(m[1] ? "strong" : "em", { texte: m[1] || m[2] }));
      dernier = re.lastIndex;
    }
    if (dernier < texte.length) f.appendChild(document.createTextNode(texte.slice(dernier)));
    return f;
  }
  function paragraphes(texte) {
    return String(texte || "").split(/\n{2,}/).filter(function (s) { return s.trim(); }).map(function (bloc) {
      var p = el("p");
      bloc.split("\n").forEach(function (ligne, i) { if (i) p.appendChild(el("br")); p.appendChild(inline(ligne)); });
      return p;
    });
  }
  function bulle(qui, contenu, classe) {
    var corps = el("div", { "class": "chat-bulle" }, [el("span", { "class": "sr", texte: qui === "moi" ? T.moi + " " : T.nino + " " })].concat(contenu));
    var li = el("li", { "class": "chat-msg" + (qui === "moi" ? " chat-msg--moi" : "") + (classe ? " " + classe : "") },
      qui === "moi" ? [corps] : [D.avatar(30), corps]);
    return li;
  }
  function placer(cle, ts, noeud) {
    /* Ordre du fil : l'horodatage ; une entrée déjà là est REMPLACÉE (même clé), jamais doublée. */
    var ancienne = etat.entrees[cle];
    if (ancienne) { D.fil.replaceChild(noeud, ancienne.noeud); ancienne.noeud = noeud; return; }
    var e = { cle: cle, ts: ts, noeud: noeud }, i = etat.ordre.length;
    while (i > 0 && etat.ordre[i - 1].ts > ts) i--;
    etat.ordre.splice(i, 0, e); etat.entrees[cle] = e;
    var suivant = etat.ordre[i + 1];
    D.fil.insertBefore(noeud, suivant ? suivant.noeud : null);
    defiler();
  }
  function retirer(cle) {
    var e = etat.entrees[cle]; if (!e) return;
    e.noeud.parentNode && e.noeud.parentNode.removeChild(e.noeud);
    etat.ordre.splice(etat.ordre.indexOf(e), 1); delete etat.entrees[cle];
  }
  function defiler() { if (D.journal) D.journal.scrollTop = D.journal.scrollHeight; }
  function note(cle, contenu) { placer(cle, Date.now(), bulle("nino", contenu)); }

  function bouton(texte, action, attrs) {
    var b = el("button", Object.assign({ type: "button", "class": "chat-bouton" }, attrs || {}), [texte]);
    b.addEventListener("click", action);
    return b;
  }
  function lien(texte, href) { return el("a", { href: href, "class": "chat-bouton chat-bouton--lien", "data-chat": "vers-parcours" }, [texte]); }

  function accueil() {
    placer("local:accueil", 0, bulle("nino", paragraphes(T.accueil)));
    var p = el("p", {}, [T.conditions + " ", el("a", { href: CFG.conditions, target: "_blank", rel: "noopener" }, [T.conditionsLien])]);
    placer("local:conditions", 1, bulle("nino", [p], "chat-msg--note"));
  }

  function reposer() {
    etat.repos = true;
    if (D.envoyer) D.envoyer.disabled = true;
    if (D.trombone) D.trombone.disabled = true;
    note("local:repos", [el("p", { texte: T.repos }), lien(T.reposLien, CFG.parcours)]);
  }

  function rendreMessage(m, dernierBot) {
    var p = m.payload || {}, contenu = [], type = p.type;
    if (m.sender === "user") {
      var t = (p.text && p.text.body) || "";
      if (!t || /^\s*\{"flow_token"/.test(t)) return null;
      return bulle("moi", paragraphes(t));
    }
    if (type === "text") contenu = paragraphes(p.text && p.text.body);
    else if (type === "image") {
      if (p.image && p.image.link) contenu.push(el("img", { "class": "chat-media", src: p.image.link, alt: (p.image.caption || ""), loading: "lazy" }));
      if (p.image && p.image.caption) contenu = contenu.concat(paragraphes(p.image.caption));
    } else if (type === "interactive" && p.interactive) {
      var it = p.interactive, h = it.header || {};
      if (h.image && h.image.link) contenu.push(el("img", { "class": "chat-media", src: h.image.link, alt: "", loading: "lazy" }));
      else if (h.text) contenu.push(el("p", {}, [el("strong", { texte: h.text })]));
      contenu = contenu.concat(paragraphes(it.body && it.body.text));
      if (it.type === "button" && it.action && it.action.buttons) {
        var puces = el("div", { "class": "chat-puces" });
        it.action.buttons.forEach(function (b) {
          var titre = b && b.reply && b.reply.title; if (!titre) return;
          var pc = el("button", { type: "button", "class": "chat-puce", disabled: !dernierBot }, [titre]);
          pc.addEventListener("click", function () { envoyerTexte(titre); });
          puces.appendChild(pc);
        });
        contenu.push(puces);
      } else if (it.type === "flow") {
        var ecran = it.action && it.action.parameters && it.action.parameters.flow_action_payload && it.action.parameters.flow_action_payload.screen;
        if (ecran === "FIRST") contenu.push(bouton(T.photos, function () { D.fichier.click(); }, { "data-chat": "ajouter-photos" }));
        else contenu.push(bouton(T.continuer, pleinEcran));
      } else if (it.type === "cta_url") {
        /* ⚠️ Le lien d'un cta_url porte un jeton historique en paramètre : il n'est JAMAIS affiché. */
        if (m.intent !== "family_ready") contenu.push(bouton(T.continuer, pleinEcran));
      }
    } else return null;
    if (!contenu.length) return null;
    return bulle("nino", contenu);
  }

  function fusionner(messages) {
    if (!messages || !messages.length) return;
    var dernierBot = null;
    messages.forEach(function (m) { if (m.sender !== "user") dernierBot = m.id; });
    messages.forEach(function (m) {
      if (!m || !m.id) return;
      var ts = m.timestamp ? Date.parse(m.timestamp) : Date.now();
      if (m.sender === "user") {
        /* Le message envoyé d'ici est déjà affiché sous son `message_id` : on ne le double pas. */
        if (etat.entrees["envoi:" + m.id]) return;
        var corpsT = (m.payload && m.payload.text && m.payload.text.body) || "";
        var attente = etat.ordre.filter(function (e) { return e.texte === corpsT && e.cle.indexOf("envoi:") === 0; })[0];
        if (attente) return;
      }
      /* 🔴 UN MESSAGE DÉJÀ AFFICHÉ N'EST PAS RECRÉÉ (revue du lot 17) : le remplacer à chaque sondage
         faisait perdre le focus clavier, relire le fil au lecteur d'écran et réactivait un bouton en cours. */
      if (etat.entrees["srv:" + m.id]) return;
      var n = rendreMessage(m, m.id === dernierBot);
      if (n) placer("srv:" + m.id, ts, n);
      if (m.intent === "family_ready" || m.intent === "family_manage") verifierFamille();
    });
    /* Seules les puces du DERNIER message de Nino restent actives, comme sur /chat. */
    Array.prototype.forEach.call(D.fil.querySelectorAll(".chat-puce"), function (pc) {
      var li = pc.closest("li"); pc.disabled = !dernierBot || li !== (etat.entrees["srv:" + dernierBot] || {}).noeud;
    });
  }

  function charger() {
    etat.charge = true;
    accueil();
    if (!jetonValide()) { familleDuCompte(); return; }
    rafraichirSiMiVie();
    appeler("GET", "/chat/messages?limit=50", undefined, true).then(function (r) {
      if (r.ok) { fusionner(r.donnees.messages); verifierFamille(); return; }
      traiterRefus(r, true);
    });
  }

  function traiterRefus(r, auChargement) {
    if (r.statut === 401 || r.statut === 403) { ecrire(CLE_JETON, null); if (!auChargement) note("local:expire", paragraphes(T.expire)); return; }
    if (r.statut === 429 && r.donnees.error === "rate_limited") { note("local:pause", paragraphes(T.pause)); return; }
    if (r.statut === 0 || r.statut >= 500 || r.statut === 429) reposer();
  }

  function sonder() {
    if (!etat.ouvert || document.hidden || !jetonValide() || Date.now() < etat.prochainSondage) return;
    etat.prochainSondage = Date.now() + 60000;
    appeler("GET", "/chat/messages?limit=20", undefined, true).then(function (r) {
      if (r.ok) { etat.echecs = 0; etat.prochainSondage = 0; fusionner(r.donnees.messages); return; }
      if (r.statut === 401 || r.statut === 403) { ecrire(CLE_JETON, null); etat.prochainSondage = 0; return; }
      etat.echecs += 1;
      etat.prochainSondage = Date.now() + Math.min(60000, SONDAGE_MS * Math.pow(2, etat.echecs));
    });
  }
  function demarrerSondage() { if (!etat.sondage) etat.sondage = window.setInterval(sonder, SONDAGE_MS); }
  function arreterSondage() { if (etat.sondage) { window.clearInterval(etat.sondage); etat.sondage = null; } }
  document.addEventListener("visibilitychange", function () { if (!document.hidden) { etat.prochainSondage = 0; sonder(); } });

  /* ── envoyer ────────────────────────────────────────────────────────────────────────────── */
  function envoyerSaisie() {
    var t = D.texte.value.trim(); if (!t || etat.repos) return;
    D.texte.value = ""; D.envoyer.disabled = true;
    envoyerTexte(t);
  }
  function envoyerTexte(t, idDeja) {
    if (etat.repos) return;
    var id = idDeja || idMessage(), cle = "envoi:" + id;
    var n = bulle("moi", paragraphes(t)); placer(cle, Date.now(), n); etat.entrees[cle].texte = t;
    retirer("local:echec:" + id);
    assurerSession("message").then(function (ok) {
      if (!ok) return;
      return appeler("POST", "/chat/messages", { message: t, message_id: id }, true).then(function (r) {
        if (r.ok) { fusionner(r.donnees.messages); etat.prochainSondage = 0; return; }
        if (r.statut === 0 || r.statut === 500) {
          note("local:echec:" + id, [el("p", { texte: T.pasEnvoye }), bouton(T.reessayer, function () { retirer(cle); envoyerTexte(t, id); })]);
          return;
        }
        traiterRefus(r, false);
      });
    });
  }

  /* ── la famille ─────────────────────────────────────────────────────────────────────────── */
  function reduire(fichier) {
    /* 1600 px au plus, JPEG 0,85 : la règle de /chat (photos.ts). Un format que le navigateur ne lit pas
       (HEIC sur Chrome) rend `null` : il est dit, jamais envoyé tel quel. */
    return new Promise(function (resoudre) {
      var url = URL.createObjectURL(fichier), img = new Image();
      img.onload = function () {
        var k = Math.min(1, PHOTO_COTE / Math.max(img.naturalWidth, img.naturalHeight));
        var c = document.createElement("canvas");
        c.width = Math.max(1, Math.round(img.naturalWidth * k)); c.height = Math.max(1, Math.round(img.naturalHeight * k));
        c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        resoudre(c.toDataURL("image/jpeg", 0.85));
      };
      img.onerror = function () { URL.revokeObjectURL(url); resoudre(null); };
      img.src = url;
    });
  }
  function envoyerPhotos(fichiers) {
    if (etat.repos) return;
    fichiers = fichiers.slice(0, PHOTOS_MAX);
    var cle = "local:photos:" + Date.now();
    placer(cle, Date.now(), bulle("moi", [el("p", { texte: T.nPhotos(fichiers.length) })]));
    Promise.all(fichiers.map(reduire)).then(function (urls) {
      var mauvaise = urls.indexOf(null);
      if (mauvaise !== -1) { note("local:photo-ko", paragraphes(T.photoKo(mauvaise + 1))); return; }
      return assurerSession("famille").then(function (ok) {
        if (!ok) return;
        return appeler("POST", "/families/me", { photos: urls }, true).then(function (r) {
          if (r.ok || r.statut === 409) { enDessin(); return; }
          if (r.statut === 400 && r.donnees.error === "invalid_photo") { note("local:photo-ko", paragraphes(T.photoKo((r.donnees.index || 0) + 1))); return; }
          if (r.statut === 429) { note("local:limite", paragraphes(T.limite)); return; }
          traiterRefus(r, false);
        });
      });
    });
  }
  function enDessin() {
    note("local:dessin", paragraphes(T.dessin).concat([el("p", { "class": "chat-etat", role: "status", texte: T.enDessin })]));
    etat.familleDepuis = Date.now();
    planifierFamille();
  }
  function planifierFamille() {
    if (etat.familleMinuteur || etat.famillePrete) return;
    etat.familleMinuteur = window.setTimeout(function () {
      etat.familleMinuteur = null;
      verifierFamille().then(function (prete) {
        if (prete) return;
        if (Date.now() - etat.familleDepuis > FAMILLE_MAX_MS) { note("local:trop-long", paragraphes(T.tropLong)); return; }
        planifierFamille();
      });
    }, FAMILLE_MS);
  }
  function verifierFamille() {
    if (etat.famillePrete) return Promise.resolve(true);
    if (!jetonValide()) return Promise.resolve(false);
    return appeler("GET", "/families/me", undefined, true).then(function (r) {
      var membres = r.ok && r.donnees.members ? r.donnees.members : [];
      if (!membres.length) return false;
      etat.famillePrete = true;
      retirer("local:dessin");
      carteFamille(membres);
      return true;
    });
  }
  function familleDuCompte() {
    /* Un COMPTE CONNECTÉ dont la famille est faite sur l'app (revue du lot 17) : la boutique n'a pas la
       session commune du chat, sa famille ne se lit que par le cookie. Lecture seule ; 401 = visiteur. */
    fetch(CFG.galerie + "/famille/import", { method: "GET", credentials: "include" }).then(function (r) {
      return r.ok ? r.json() : null;
    }).then(function (d) {
      if (!d || !d.prete || etat.famillePrete) return;
      etat.famillePrete = true;
      carteFamille([]);
    }, function () { /* galerie muette : rien à dire, le panneau reste utilisable */ });
  }
  function carteFamille(membres) {
    var grille = el("div", { "class": "chat-portraits" });
    membres.slice(0, 6).forEach(function (m) {
      var src = m.illustrationStoragePathMedium || m.illustrationStoragePath;
      if (src) grille.appendChild(el("img", { src: src, alt: m.name || m.role || "", width: "1024", height: "1024", loading: "lazy" }));
    });
    var b = bouton(T.versFiche, versFiche, { "class": "chat-bouton chat-bouton--action", "data-chat": "vers-fiche" });
    placer("local:famille", etat.carteFamille ? etat.entrees["local:famille"].ts : Date.now(),
      bulle("nino", [el("p", { texte: T.prete }), grille, b], "chat-msg--large"));
    etat.carteFamille = true;
  }
  function versFiche(e) {
    var b = e && e.currentTarget; if (b) { b.disabled = true; b.textContent = T.versFicheEnCours; }
    var j = jetonValide();
    var rendre = function () { if (b) { b.disabled = false; b.textContent = T.versFiche; } };
    fetch(CFG.galerie + "/famille/import", {
      /* Le cookie ne voyage que s'il EST la preuve (compte connecté, sans jeton chat) : avec le jeton,
         une galerie qui ne renvoie pas `allow-credentials` ferait rejeter la réponse (revue du lot 17). */
      method: "POST", headers: { "Content-Type": "application/json" }, credentials: j ? "omit" : "include",
      body: JSON.stringify(j ? { chat: j, uid: uidSession() } : {})
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) { return { statut: r.status, d: d }; });
    }, function () { return { statut: 0, d: {} }; }).then(function (r) {
      if (r.statut === 200 && r.d.jeton) { ouvrirFiche(r.d.jeton); return; }
      rendre();
      if (r.statut === 409) { note("local:presque", paragraphes(T.presque)); return; }
      note("local:import-ko", [el("p", { texte: T.importKo }), lien(T.reposLien, CFG.parcours)]);
    });
  }
  function ouvrirFiche(jeton) {
    /* Le jeton de galerie suit la navigation par l'ONGLET (clé du bloc de la fiche), jamais par l'adresse.
       Stockage refusé (navigation privée) → le fragment `#tms=`, que le bloc lit puis efface. */
    var range = true;
    try { window.sessionStorage.setItem(CLE_GALERIE, jeton); } catch (e) { range = false; }
    var cible = CFG.fiche + (range ? "#order-preview" : "#tms=" + encodeURIComponent(jeton));
    var memePage = window.location.pathname.replace(/\/$/, "") === CFG.fiche.replace(/\/$/, "");
    window.location.assign(cible);
    if (memePage) window.location.reload();
  }

  /* ── plein écran ────────────────────────────────────────────────────────────────────────── */
  function pleinEcran() {
    var j = jetonValide();
    var url = CFG.app + "?lang=" + LANGUE_API + (j ? "&token=" + encodeURIComponent(j) : "");
    var w = window.open(url, "_blank", "noopener");
    if (w) w.opener = null;
  }

  /* ── le lanceur : partout, sauf pendant le parcours de l'accueil ──────────────────────────── */
  function parcoursEngage() {
    var carte = document.querySelector("[data-tms-depot-heros]");
    var porteur = document.querySelector("[data-tms-etat]");
    var e = porteur ? porteur.getAttribute("data-tms-etat") : null;
    return !!((carte && carte.hidden) || (e && e !== "vide"));
  }
  function effacerPendantParcours() {
    if (etat.ouvert) return;
    /* ⚠️ N'écrire QUE si ça change : l'observateur ci-dessous écoute `hidden`, et réécrire la même valeur
       produit quand même une mutation — donc une boucle sans fin. */
    var cacher = !etat.appele && (CFG.discret || parcoursEngage());
    if (lanceur.hidden !== cacher) lanceur.hidden = cacher;
  }
  lanceur.addEventListener("click", function () { if (etat.ouvert) fermer(); else ouvrir(); });
  /* 🔴 D7 (lot 11 comptes) : un ÉCHEC de la famille appelle Nino (`tms-gallery.js`, événement `tms:chat-ouvrir`) avec un
     message pré-rempli qui porte la référence de la famille. Le client le relit et l'ENVOIE lui-même : rien ne part sans
     son geste (la session, qui vaut inscription, naît toujours au premier envoi). Une saisie déjà commencée est gardée. */
  function surAppel(detail) {
    var message = detail && detail.message;
    window.__tmsChatOuvrir = null;
    etat.appele = true;
    lanceur.hidden = false;
    if (!etat.ouvert) ouvrir();
    if (message && D.texte && !D.texte.value) {
      D.texte.value = String(message);
      try { D.texte.dispatchEvent(new Event("input", { bubbles: true })); } catch (e) { /* vieux navigateur */ }
    }
    if (D.texte) D.texte.focus();
  }
  document.addEventListener("tms:chat-ouvrir", function (ev) { surAppel(ev && ev.detail); });
  /* Un appel arrivé AVANT ce script (l'échec annoncé pendant qu'il se chargeait) est servi maintenant. */
  if (window.__tmsChatOuvrir) surAppel(window.__tmsChatOuvrir);
  voile.addEventListener("click", function () { fermer(); });
  lanceur.setAttribute("aria-label", T.lanceur);
  effacerPendantParcours();
  if (window.MutationObserver) {
    new MutationObserver(effacerPendantParcours).observe(document.body, {
      subtree: true, attributes: true, attributeFilter: ["hidden", "data-tms-etat"]
    });
  }
  if (ecranEtroit.addEventListener) ecranEtroit.addEventListener("change", function () {
    if (!etat.ouvert) return;
    var modal = !!ecranEtroit.matches;
    flottant.setAttribute("aria-modal", modal ? "true" : "false"); voile.hidden = !modal;
  });
})();
